const initOnlineExclusiveOffersSwiper = (root) => {
  if (typeof window.Swiper !== 'function') return;
  if (!root) return;

  const swiperEl = root.querySelector('.online-exclusive-offers__swiper');
  if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

  const wrap = swiperEl.closest('.online-exclusive-offers__swiper-wrap');
  if (!wrap) return;

  const prevEl = wrap.querySelector('.online-exclusive-offers__arrow--prev');
  const nextEl = wrap.querySelector('.online-exclusive-offers__arrow--next');
  const paginationEl = wrap.querySelector('.online-exclusive-offers__pagination');

  const updateCenteredState = (swiper) => {
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    const isTablet = window.matchMedia('(min-width: 750px) and (max-width: 1249px)').matches;
    const slidesCount = swiper?.slides?.length || 0;
    const slidesPerViewDesktop = isTablet ? 3.5 : 4;
    const shouldCenter = isDesktop && slidesCount < slidesPerViewDesktop;

    wrap.classList.toggle('online-exclusive-offers__swiper-wrap--centered', shouldCenter);
  };

  const instance = new Swiper(swiperEl, {
    slidesPerView: 1.5,
    slidesPerGroup: 1,
    spaceBetween: 10,
    centeredSlides: false,
    loop: false,
    breakpoints: {
      750: {
        slidesPerView: 3.5,
        spaceBetween: 10
      },
      1250: {
        slidesPerView: 4,
        spaceBetween: 10
      }
    },
    navigation:
      prevEl && nextEl
        ? {
            nextEl,
            prevEl
          }
        : false,
    pagination:
      paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : false,
    on: {
      init() {
        swiperEl.classList.add('swiper-initialized');
        updateCenteredState(this);
      },
      resize() {
        updateCenteredState(this);
      },
      breakpoint() {
        updateCenteredState(this);
      }
    }
  });

  // Store instance if needed later
  swiperEl._onlineExclusiveOffersSwiper = instance;
};

// Initial load: init every Online Exclusive Offers section on the page.
document.addEventListener('DOMContentLoaded', () => {
  const roots = document.querySelectorAll('.online-exclusive-offers[data-section-id]');
  roots.forEach((root) => initOnlineExclusiveOffersSwiper(root));
});

// Theme editor / dynamic reloads: initialize for the specific section that was loaded.
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.matches('.online-exclusive-offers[data-section-id]')) {
    initOnlineExclusiveOffersSwiper(event.target);
  }
});
